export default __webpack_public_path__ + "static/media/homehero2.e8bbc46a.png";